import fileDownload from 'js-file-download';
import { put } from 'redux-saga/effects';
import { APIgetNV05ExcelData, APIgetProductgroupListByFirm } from '../../felles/APICalls_NV05';
import PageImpl from '../../models/PageImpl';
import * as actions from '../actions';
import * as actionsNV05 from '../actions/indexNV05';

//
export function* getNV05ListSaga(payload) {
  try {
    yield put(actions.setIsloading(true));
    const { listFormData } = payload;
    let response;
    if (listFormData.exportToExcel) {
      response = yield APIgetNV05ExcelData(listFormData);
    } else {
      response = yield APIgetProductgroupListByFirm(listFormData);
    }
    if (response?.data) {
      if (listFormData.exportToExcel) {
        yield fileDownload(response.data, `NV05-list__${Date.now()}.xlsx`);
      } else {
        yield put(actionsNV05.NV05ListeGetSuccess(response.data as PageImpl<any>));
      }
    }
  } catch (error) {
    yield put(actionsNV05.NV05ListeGetFailed(error));
  } finally {
    yield put(actions.setIsloading(false));
  }
}
